import * as React from "react"

const SvgHeartFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21.04q-.349 0-.713-.126a1.65 1.65 0 0 1-.637-.4L8.925 18.94a68 68 0 0 1-4.788-4.812Q2.001 11.738 2 8.864q0-2.35 1.575-3.925T7.5 3.364q1.325 0 2.5.563t2 1.537a5.96 5.96 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575Q22 6.515 22 8.864q0 2.875-2.125 5.275a60 60 0 0 1-4.825 4.825l-1.7 1.55a1.65 1.65 0 0 1-.637.4q-.363.125-.713.125Z" />
  </svg>
)
export default SvgHeartFilled
